import { inputColors } from './consts';
const baseStyle = {
    container: {
        focusWithinRing: 2,
        color: inputColors.inputText
    },
    input: {
        placeholderTextColor: inputColors.placeholder
    }
};
const defaultProps = {
    size: 'lg',
    variant: 'grey'
};
const parts = ['container', 'icon', 'input'];
const sizes = {
    sm: {
        container: {
            fontSize: 'sm',
            h: 24
        },
        icon: {
            size: 'xs'
        },
        input: {}
    },
    md: {
        container: {
            fontSize: 'sm',
            h: 32
        },
        icon: {
            size: 'sm'
        },
        input: {}
    },
    lg: {
        container: {
            fontSize: 'md',
            h: 40
        },
        icon: {
            size: 'md'
        },
        input: {}
    },
    xl: {
        container: {
            fontSize: 'lg',
            h: 48
        },
        icon: {
            size: 'md'
        },
        input: {}
    }
};
const variants = {
    grey: {
        container: {
            borderColor: inputColors.border,
            focusWithinRingColor: inputColors.focus
        }
    },
    green: {
        container: {
            borderColor: inputColors.success,
            focusWithinRingColor: inputColors.success
        }
    },
    red: {
        container: {
            borderColor: inputColors.error,
            focusWithinRingColor: inputColors.error
        }
    }
};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
